import {
    AccessibilityNew, Biotech, 
    ShoppingCartCheckout,
    PrecisionManufacturing,
    MobileFriendly,
    CarRental,
    Restaurant,
    SettingsInputAntenna,
    AirplaneTicketOutlined,
    AppRegistration,
    AttachMoney,
    LocalFloristOutlined,
} from '@mui/icons-material';

interface _Industry {
    id: string | undefined,
    title: string | undefined,
    briefDescription: string | undefined,
    icon: typeof AccessibilityNew | undefined,
    isVisible?: boolean,
}

export class Industry implements _Industry {
    constructor(
        public id: string | undefined,
        public title: string | undefined,
        public briefDescription: string | undefined,
        public icon: typeof AccessibilityNew | undefined,
        public isVisible: boolean = true,
    ) {
    }
}


export const industryList: Industry[] = [
    {
        id: "industry_hightech",
        title: "High Tech",
        briefDescription: "Mobile devices integrating with software technologies and/or connected hardware.",
        icon: PrecisionManufacturing,
        isVisible: true,
    },
    {
        id: "industry_retail",
        title: "Retail",
        briefDescription: "Businesses selling goods directly to consumers through omni-channels for storefront or online sales and marketing.",
        icon: ShoppingCartCheckout,
        isVisible: true,
    },
    {
        id: "industry_consumer_goods",
        title: "Consumer Goods",
        briefDescription: "Products purchased by individuals for personal use, encompassing a wide range of items from food and clothing to electronics and appliances.",
        icon: LocalFloristOutlined, //Interests,
        isVisible: true,
    },
    {
        id: "industry_gov",
        title: "Government",
        briefDescription: "Public sector organizations at various levels (local, regional, national) responsible for governance, public services, and policy implementation.",
        icon: AttachMoney,  // RailwayAlert,
        isVisible: true,
    },
    {
        id: "industry_automotive",
        title: "Automotive",
        briefDescription: "Companies involved in the design, manufacture, marketing, and sale of motor vehicles.",
        icon: CarRental,
        isVisible: true,
    },
    {
        id: "industry_restaurant",
        title: "Restaurant",
        briefDescription: "Businesses preparing and serving food and beverages to customers in a dining setting or take-out environment and delivery.",
        icon: Restaurant,
        isVisible: true,
    },
    {
        id: "industry_life_health",
        title: "Life & Health Sciences",
        briefDescription: "Encompasses pharmaceuticals, biotechnology, medical devices, and healthcare services focused on improving human health and well-being.",
        icon: Biotech,
        isVisible: false,
    },
    {
        id: "industry_insurance",
        title: "Insurance",
        briefDescription: "Companies providing risk management services by offering financial protection against potential losses in exchange for premiums.",
        icon: AppRegistration,
        isVisible: false,
    },
    {
        id: "industry_travel",
        title: "Travel",
        briefDescription: "Businesses facilitating travel arrangements, including airlines, hotels, travel agencies, and online booking platforms.",
        icon: AirplaneTicketOutlined,
        isVisible: true,
    },
    {
        id: "industry_comm",
        title: "Communications",
        briefDescription: "Companies providing communication services, including telecommunications, media, and internet providers.",
        icon: SettingsInputAntenna,
        isVisible: true,
    },
    // {
    //     id: "industry_TBD",
    //     title: "Z TBD",
    //     icon: StopCircle,
    // },
];
